function createFolderDialog () {
  return {
    restrict: 'E',
    templateUrl: '/repository/dialogs/create-folder/create-folder-dialog.html?$$REVISION$$'
  }
}

export { createFolderDialog }
